export default {
  transaction: {
    title: 'Transação',
    select: 'Selecionar',
    all: 'Todos',
    loading: 'Carregando...',
    noMoreData: 'Sem mais dados',
    mockSuccess: 'Sucesso Simulado',
    mockFail: 'Falha Simulada',
    mockSuccessDone: 'Sucesso simulado concluído',
    mockFailDone: 'Falha simulada concluída',
    mockFailed: 'Simulação falhou',
    today: 'Hoje',
    yesterday: 'Ontem',
    last3Days: 'Últimos 3 dias',
    last7Days: 'Últimos 7 dias',
    last15Days: 'Últimos 15 dias',
    last30Days: 'Últimos 30 dias',
    allTypes: 'Todos os tipos',
    deposit: 'Depósito',
    withdrawal: 'Saque',
    withdrawalRefund: 'Reembolso de saque',
    bet: 'Aposta',
    win: 'Ganho',
    manualAdd: 'Adição manual',
    manualSubtract: 'Subtração manual',
    commission: 'Comissão',
    bonus: 'Bônus',
    vipUpgradeReward: 'Recompensa de upgrade VIP',
    vipSalary: 'Salário VIP',
    gameOutPrincipal: 'Saída de jogo - Principal',
    gameOutBonus: 'Saída de jogo - Bônus',
    bonusTransferOut: 'Transferência de bônus',
    allStats: 'Todos os status',
    underReview: 'Em análise',
    pendingPayout: 'Pagamento pendente',
    successful: 'Bem-sucedido',
    failed: 'Falhou',
    cancelled: 'Cancelado',
    processing: 'Processando',
  },
};
